module.exports = __webpack_public_path__ + "img/banner-ru-mobile.2d255ec9.jpg";